import { useQuery } from 'hooks/useCustomQuery';
import { fetchRegistrars } from 'API/TRSRegistrar/fetchRegistrars';

const useRegistrarsMini = (currentCompany) =>
    useQuery({
        queryKey: ['Registrars'],
        queryFn: () => fetchRegistrars(currentCompany),
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
        enabled: !!currentCompany,
    });

export { useRegistrarsMini };
